import { useState } from 'react';
import { Alert, Box, CircularProgress, Link, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MDButton from '@components/MDButton';
import { apiErrorMessage } from '@functions/api-error-message';
import { AUTH_FIELD_SX, AuthLayout } from '../sign-in/auth-layout';
import { PasswordService, maskEmail } from './password.service';

/// A confirmação é igual com ou sem cadastro, para não revelar quem é cliente.
export const ForgotPasswordScreen = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    // O e-mail que já estava digitado no login, para não digitar de novo.
    const [email, setEmail] = useState<string>((location.state as { email?: string } | null)?.email ?? '');
    const [sending, setSending] = useState(false);
    const [error, setError] = useState('');
    const [sent, setSent] = useState(false);

    const send = async (e: React.FormEvent) => {
        e.preventDefault();

        if (sending) return;

        setError('');
        setSending(true);

        try {
            await new PasswordService().forgot(email.trim());
            setSent(true);
        } catch (err) {
            setError(apiErrorMessage(err));
        } finally {
            setSending(false);
        }
    };

    const backToLogin = (
        <Box sx={{ textAlign: 'center' }}>
            <Link
                component="button"
                type="button"
                onClick={() => navigate('/', { replace: true })}
                sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 13 }}
            >
                {t('senha.voltarAoLogin')}
            </Link>
        </Box>
    );

    if (sent) {
        return (
            <AuthLayout subtitle={t('senha.enviadoTitulo')}>
                <Typography sx={{ color: 'rgba(255,255,255,0.85)', fontSize: 14, textAlign: 'center' }}>
                    {t('senha.enviadoAviso', { email: maskEmail(email) })}
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: 12.5, textAlign: 'center' }}>
                    {t('senha.enviadoRodape')}
                </Typography>
                {backToLogin}
            </AuthLayout>
        );
    }

    return (
        <AuthLayout subtitle={t('senha.esqueciAviso')} onSubmit={send}>
            {error && (
                <Alert severity="error" icon={false} sx={{ py: 0.5 }}>
                    <Typography variant="caption">{error}</Typography>
                </Alert>
            )}

            <TextField
                type="email"
                label={t('auth.email')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                autoComplete="username"
                sx={AUTH_FIELD_SX}
            />

            <MDButton type="submit" variant="gradient" color="info" size="large" disabled={sending}>
                {sending ? <CircularProgress size={18} color="inherit" /> : t('senha.enviarLink')}
            </MDButton>

            {backToLogin}
        </AuthLayout>
    );
};
